import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '../../components/iconify/Iconify';
import { useStyles } from '../../pages/projects/list/styles/projectFormModalStyles';

// ----------------------------------------------------------------------

export default function ProfileHeader({ 
  userId, 
  userData, 
  isEditing, 
  canEdit, 
  isSubmitting, 
  onEdit, 
  onCancel, 
  onSubmit 
}) {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} sx={{ mt: 1 }}>
      <Typography 
        align='center' 
        className={classes.memberUpdateModelTitle}
      >
        {userId ? `${userData?.userName || 'User'} Profile` : 'My Profile'}
      </Typography>
      
      {canEdit && (
        <Box>
          {!isEditing ? (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:edit-outline" />}
              onClick={onEdit}
              sx={{ 
                backgroundColor: '#2065D1',
                '&:hover': { backgroundColor: '#103996' }
              }}
            >
              Edit Profile
            </Button>
          ) : (
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                onClick={onCancel}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                onClick={onSubmit}
                loading={isSubmitting}
                sx={{ 
                  backgroundColor: '#2065D1',
                  '&:hover': { backgroundColor: '#103996' }
                }}
              >
                Save Changes
              </LoadingButton>
            </Stack>
          )}
        </Box>
      )}
    </Box>
  );
}
